<div class="shadow mt-3">
    <div class="card {{class}}">
        <button mat-fab matTooltip="Nuevo poligono" (click)="openDialog('new',{})" class="fab ">
            <mat-icon>add</mat-icon>
        </button>
        <div class="card-header margin-top d-flex align-items-center justify-content-between flex-wrap"
            style="gap: 1rem;">

            <div style="font-family: 'Lato'; margin-top: 1.5rem;" *ngIf="title != '' || description != ''"
                class="margin-top d-flex align-items-baseline justify-content-start flex-column flex-sm-column text-left flex-wrap">
                <h2 *ngIf="title != ''" class="m-0 mr-2">{{title | slice:0:100 | uppercase}}</h2>
                <small *ngIf="description != ''" class="title-description" style="max-width: 600px;">{{description |
                    slice:0:200}}</small>
            </div> <!-- fin div title y description -->
            <mat-form-field appearance="fill" class="w-100">
                <mat-label style="font-family: 'Lato';">Buscar</mat-label>
                <input style="font-family: 'Lato';" matInput type="text" placeholder="Buscar"
                    (keyup)="applyFilter($event)" #input>
                <mat-icon matSuffix>search</mat-icon>
            </mat-form-field>
        </div>
        <div style="font-family: 'Lato';" class="card-body text-center" *ngIf="data.length==0">
            No hay registros que mostrar
        </div>
        <div class="card-body overflow-auto p-0 ">
            <div class="alert alert-info mb-2 mx-2" *ngIf="data.length>0">
                Haga clic en un registro para seleccionarlo y habilitar las opciones de Selección Geográfica y
                Capacidades por Cúbica+.
            </div>
            <table mat-table *ngIf="data.length>0" [dataSource]="dataSource">

                <ng-container matColumnDef="{{item.name}}" *ngFor="let item of columns">
                    <th mat-header-cell *matHeaderCellDef class="pr-3 pl-3">{{item.title|uppercase}}</th>
                    <div *ngIf="item.name != 'actions'">
                        <td mat-cell *matCellDef="let element" [ngClass]="{'text-break': render(item, element).length>40,
                          'text-wrap':render(item, element).length>20, 'text-nowrap':render(item, element).length<=20}"
                            class="p-1 pr-3 pl-3">
                            <span [innerHTML]="render(item, element)"></span>
                            <button *ngIf="item.name === 'USUARIO_MODIFICACION' && element.USUARIO_MODIFICACION" 
                                    mat-icon-button 
                                    matTooltip="Ver histórico" 
                                    (click)="abrirModalHistorico(element.ID_POLI)"
                                    style="vertical-align: middle; margin-left: 5px;">
                                <mat-icon style="font-size: 18px; width: 18px; height: 18px;">history</mat-icon>
                            </button>
                        </td>
                    </div>
                    <div *ngIf="item.name == 'actions'">
                        <td mat-cell *matCellDef="let element" class="p-1 pr-3 pl-3 td-align-center">
                            <button mat-icon-button matTooltip="Editar" (click)="openDialog('edit',element)">
                                <mat-icon>create</mat-icon>
                            </button>
                            <button mat-icon-button
                                [matTooltip]="element.ESTADO_LEGIBLE=='Activo' ? 'Desactivar': 'Activar'"
                                (click)="openDialog('delete',element)">
                                <mat-icon>{{element.ESTADO_LEGIBLE=='Activo'? 'toggle_on' : 'toggle_off' }}</mat-icon>
                            </button>
                        </td>
                    </div>

                </ng-container>


                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                    [class.demo-row-is-clicked]="selected.has(row)" (click)="selectRow(row)"></tr>
            </table>


        </div>
        <mat-paginator #paginatorPoligono [pageSizeOptions]="pageSizeOptions.length > 0 ? pageSizeOptions : [10,20,50,100]"
               showFirstLastButtons class="card-footer">
        </mat-paginator>
    </div>

    <br />

    <div class="card {{class}}" *ngIf="bandera">
        <div class="card-header margin-top d-flex flex-column flex-lg-row align-items-start align-items-lg-center justify-content-between"
            style="gap: 1rem;">
            <div style="font-family: 'Lato'; margin-top: 1.5rem;" *ngIf="title2 != '' || description2 != ''"
                class="margin-top d-flex align-items-baseline justify-content-start flex-column text-left flex-wrap w-100 w-lg-auto">
                <div class="d-flex align-items-center justify-content-between w-100 mb-2">
                    <h2 *ngIf="title2 != ''" class="m-0 mr-2">{{title2 | slice:0:100 | uppercase}}</h2>
                    <button mat-icon-button matTooltip="Ver histórico de geografías" 
                            (click)="abrirModalHistoricoGeografia()" 
                            *ngIf="selectedRow"
                            class="historico-btn">
                        <mat-icon>history</mat-icon>
                    </button>
                </div>
                <small *ngIf="description2 != ''" class="title-description" style="max-width: 600px;">{{description2 |
                    slice:0:200}}</small>
                <div *ngIf="selectedRow" class="mt-2 alert alert-info d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center">
                    <span><strong>Cúbica+ seleccionada:</strong> {{selectedRow?.NOMBRE_POLIGONO}} (ID: {{selectedRow?.ID_POLI}})</span>
                </div>
                <!-- <div class="d-flex flex-column flex-sm-row align-items-start align-items-sm-center">
                        <span class="me-2 mb-2 mb-sm-0">Refrescar geografías -></span>
                        <button mat-icon-button matTooltip="Refrescar geografías" (click)="refrescarGeografias()">
                            <mat-icon>refresh</mat-icon>
                        </button>
                </div> -->
            </div>
            <div class="selector-container w-100 w-lg-auto" *ngIf="selectedRow">

                <div class="selector-group d-flex flex-column flex-md-row" style="gap: 1rem;">
                    <!-- DEPARTAMENTOS -->
                    <div class="selector-card flex-fill">
                        <div class="selector-header d-flex justify-content-between align-items-center">
                            <div class="d-flex align-items-center">
                                <mat-icon style="font-size: 16px;">info</mat-icon>
                                <span class="ms-2">Departamentos</span>
                            </div>
                            <div class="d-flex">
                                <button mat-icon-button matTooltip="Nuevo departamento"
                                    (click)="abrirModalAgregar('departamento',{ID_POLI: selectedRow?.ID_POLI})">
                                    <mat-icon>add</mat-icon>
                                </button>
                                <button mat-icon-button matTooltip="Refrescar geografías" (click)="refrescarGeografias()">
                                    <mat-icon>refresh</mat-icon>
                                </button>
                            </div>
                        </div>
                        <mat-form-field appearance="fill" class="w-100 px-2">
                            <mat-label>Buscar</mat-label>
                            <input matInput [(ngModel)]="filtroDepartamento" placeholder="Buscar departamento">
                        </mat-form-field>
                        <div class="selector-list scrollable">
                            <div *ngFor="let depto of departamentosFiltrados()" class="selector-item d-flex justify-content-between align-items-center">
                                <span class="selector-label">{{depto.NOMBRE_DEPARTAMENTO}}</span>
                                <button mat-icon-button matTooltip="Eliminar"
                                    (click)="eliminarGeografia('departamento', depto,{ID_POLI: selectedRow?.ID_POLI})">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- MUNICIPIOS -->
                    <div class="selector-card flex-fill">
                        <div class="selector-header d-flex justify-content-between align-items-center">
                            <div class="d-flex align-items-center">
                                <mat-icon>location_city</mat-icon>
                                <span class="ms-2">Municipios</span>
                            </div>
                            <button mat-icon-button matTooltip="Nuevo municipio"
                                (click)="abrirModalAgregar('municipio',{ID_POLI: selectedRow?.ID_POLI})">
                                <mat-icon>add</mat-icon>
                            </button>
                            <button mat-icon-button matTooltip="Refrescar geografías" (click)="refrescarGeografias()">
                                <mat-icon>refresh</mat-icon>
                            </button>
                        </div>
                        <mat-form-field appearance="fill" class="w-100 px-2">
                            <mat-label>Buscar</mat-label>
                            <input matInput [(ngModel)]="filtroMunicipio" placeholder="Buscar municipio">
                        </mat-form-field>
                        <div class="selector-list scrollable">
                            <div *ngFor="let mun of municipiosFiltrados()" class="selector-item d-flex justify-content-between align-items-center">
                                <span class="selector-label">{{mun.NOMBRE_MUNICIPIO}} ({{mun.COD_DPTO}})</span>
                                <button mat-icon-button matTooltip="Eliminar"
                                    (click)="eliminarGeografia('municipio', mun,{ID_POLI: selectedRow?.ID_POLI})">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- ZONAS -->
                    <div class="selector-card flex-fill">
                        <div class="selector-header d-flex justify-content-between align-items-center">
                            <div class="d-flex align-items-center">
                                <mat-icon>map</mat-icon>
                                <span class="ms-2">Zonas</span>
                            </div>
                            <button mat-icon-button matTooltip="Nueva zona" (click)="abrirModalAgregar('zona',{ID_POLI: selectedRow?.ID_POLI})">
                                <mat-icon>add</mat-icon>
                            </button>
                            <button mat-icon-button matTooltip="Refrescar geografías" (click)="refrescarGeografias()">
                                <mat-icon>refresh</mat-icon>
                            </button>
                        </div>
                        <mat-form-field appearance="fill" class="w-100 px-2">
                            <mat-label>Buscar</mat-label>
                            <input matInput [(ngModel)]="filtroZona" placeholder="Buscar zona">
                        </mat-form-field>
                        <div class="selector-list scrollable">
                            <div *ngFor="let zona of zonasFiltradas()" class="selector-item d-flex justify-content-between align-items-center">
                                <span class="selector-label">{{zona.NOMBRE_ZONA}} ({{zona.COD_DPTO}})</span>
                                <button mat-icon-button matTooltip="Eliminar" (click)="eliminarGeografia('zona', zona,{ID_POLI: selectedRow?.ID_POLI})">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>

                </div>

            </div>

        </div>
    </div>

    <br />

    <div class="card {{class}}" *ngIf="bandera2">
        <button mat-fab matTooltip="Nueva capacidad" (click)="openDialog('new_capa',{ID_POLI: selectedRow?.ID_POLI, capacidadesExistentes: data_capa})" class="fab">
            <mat-icon>add</mat-icon>
        </button>
        <button mat-fab matTooltip="Ver histórico de capacidades" 
                (click)="abrirModalHistoricoCapacidades()" 
                *ngIf="selectedRow"
                class="fab-historico">
            <mat-icon>history</mat-icon>
        </button>
        <div class="card-header margin-top d-flex align-items-center justify-content-between flex-wrap"
            style="gap: 1rem;">
            <div style="font-family: 'Lato';" *ngIf="title3 != '' || description3 != ''"
                class="margin-top d-flex align-items-baseline justify-content-start flex-column flex-sm-column text-left flex-wrap">
                <h2 *ngIf="title3 != ''" class="m-0 mr-2">{{title3 | slice:0:100 | uppercase}}</h2>
                <small *ngIf="description3 != ''" class="title-description" style="max-width: 600px;">{{description3 |
                    slice:0:200}}</small>
                <div *ngIf="selectedRow" class="mt-2 alert alert-info">
                    <strong>Cúbica+ seleccionada:</strong> {{selectedRow?.NOMBRE_POLIGONO}} (ID:
                    {{selectedRow?.ID_POLI}})
                </div>
            </div>
            <mat-form-field appearance="fill" class="w-100">
                <mat-label style="font-family: 'Lato';">Buscar</mat-label>
                <input style="font-family: 'Lato';" matInput type="text" placeholder="Buscar"
                    (keyup)="applyFilterCapacidades($event)" #input>
                <mat-icon matSuffix>search</mat-icon>
            </mat-form-field>
            <div style="font-family: 'Lato';" class="card-body text-center" *ngIf="data_capa.length==0">
                No hay registros que mostrar
            </div>
            <div class="card-body overflow-auto p-0 ">
                <table mat-table *ngIf="data_capa.length>0" [dataSource]="dataSourCapa">

                    <ng-container matColumnDef="{{item.name}}" *ngFor="let item of columns_capa">
                        <th mat-header-cell *matHeaderCellDef class="pr-3 pl-3">{{item.title|uppercase}}</th>
                        <div *ngIf="item.name != 'actions'">
                            <td mat-cell *matCellDef="let element" [ngClass]="{'text-break': render(item, element).length>40,
                          'text-wrap':render(item, element).length>20, 'text-nowrap':render(item, element).length<=20}"
                                class="p-1 pr-3 pl-3" [innerHTML]="render(item, element)">
                                <!-- <span class="mobile-label mr-2">{{item.title|uppercase}}:</span>
                                {{render(item, element)}} -->
                            </td>
                        </div>
                        <div *ngIf="item.name == 'actions'">
                            <td mat-cell *matCellDef="let element" class="p-1 pr-3 pl-3 td-align-center">
                                <button mat-icon-button matTooltip="Editar"
                                    (click)="iniciarEdicionCapacidad(element)">
                                    <mat-icon>edit</mat-icon>
                                </button>
                                <button mat-icon-button matTooltip="Alertas"
                                    (click)="abrirModalAlertas(element)">
                                    <mat-icon>notifications</mat-icon>
                                </button>
                                <button mat-icon-button matTooltip="Ver capacidad días"
                                    (click)="abrirModalCapacidadDias(element)">
                                    <mat-icon>calendar_view_day</mat-icon>
                                </button>
                                <button mat-icon-button matTooltip="Eliminar"
                                    (click)="confirmarEliminarCapacidad(element)">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </td>
                        </div>

                    </ng-container>


                    <tr mat-header-row *matHeaderRowDef="displayedColumns_capa"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns_capa;"
                        [class.demo-row-is-clicked]="selected_capa.has(row)" (click)="selectRow_capa(row)"></tr>
                </table>


            </div>
            <mat-paginator #paginatorCapa [pageSizeOptions]="pageSizeOptions_capa.length > 0 ? pageSizeOptions_capa : [10,20,50,100]"
               showFirstLastButtons class="card-footer">
            </mat-paginator>

        </div>
    </div>

<!-- Template del diálogo de edición de capacidad general -->
<ng-template #editCapaDialog>
  <h2 mat-dialog-title class="d-flex align-items-center gap-2">
    <mat-icon>edit</mat-icon>
    Editar Capacidad General
  </h2>
  <div mat-dialog-content *ngIf="editandoCapacidad">
    <p class="text-muted mb-3" style="font-size:13px">
      ID: <strong>{{editandoCapacidad.ID_REG}}</strong> &nbsp;|&nbsp; Bodega: <strong>{{editandoCapacidad.COD_BODEGA}}</strong>
    </p>
    <div class="row g-3">
      <div class="col-12">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Cierre Automático</mat-label>
          <mat-select [(ngModel)]="editCapaForm.CIERRE_AUTOMATICO">
            <mat-option value="S">Sí</mat-option>
            <mat-option value="N">No</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-12" *ngIf="editCapaForm.CIERRE_AUTOMATICO === 'S'">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>% Cierre</mat-label>
          <input matInput type="number" min="1" max="100" [(ngModel)]="editCapaForm.PORCENTAJE_CIERRE">
          <span matSuffix>%</span>
        </mat-form-field>
      </div>
      <div class="col-12">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Cubicaje Total</mat-label>
          <input matInput type="number" step="0.01" min="0" [(ngModel)]="editCapaForm.CUBICAJE_TOTAL">
        </mat-form-field>
      </div>
      <div class="col-12">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Cantidad Órdenes Total</mat-label>
          <input matInput type="number" min="0" [(ngModel)]="editCapaForm.CANTIDAD_ORD_TOTAL">
        </mat-form-field>
      </div>
    </div>
  </div>
  <div mat-dialog-actions align="end">
    <button mat-button (click)="cancelarEdicionCapacidad()">
      <mat-icon>close</mat-icon> Cancelar
    </button>
    <button mat-raised-button color="primary" (click)="guardarEdicionCapacidad()">
      <mat-icon>save</mat-icon> Guardar
    </button>
  </div>
</ng-template>

</div>